export default "__VITE_ASSET__C7uvVzb9__"